<div [formGroup]="priceFormGroup">
  <div class="px-2">
    <div class="form-row row">
      <label class="col-2 control-label">{{'i18n.shared.fields.tariff-currency' | translate}}:</label>
      <div class="col-10 col-lg-4">
        <app-button-group [fieldsEnum]="CurrencyEnum"
                          id="tariffCurrency"
                          formControlName="tariffCurrency"
                          [translateKey]="'i18n.shared.currencies.'"></app-button-group>
      </div>
    </div>
    <div class="form-row row">
      <label class="col-2 control-label">{{'i18n.domain.administration.tariff-details.price-tab.price-type' | translate}}:</label>

      <div class="col-10 col-lg-4">
        <app-button-group [fieldsEnum]="PriceTypeEnum"
                          id="priceType"
                          formControlName="priceType"
                          [translateKey]="'i18n.domain.administration.tariff-details.price-tab.price-types.'"></app-button-group>
      </div>
    </div>
    <ng-container [ngSwitch]="priceType">
      <div *ngSwitchCase="PriceTypeEnum.LinearPrice">
        <div class="form-row row">
          <label class="col-2 control-label required">{{'i18n.domain.administration.tariff-details.price-tab.linearPriceMinStepInMinutes' | translate}}:</label>

          <div class="col-10 col-lg-4 input-wrapper">
            <ejs-numerictextbox format='n' decimals="0" formControlName="linearPriceMinStepInMinutes" name='linearPriceMinStepInMinutes' validateDecimalOnType="true" min="1"></ejs-numerictextbox>
            <span class="multichar-unit-numerictextbox">min</span>
            <app-error-messages [control]="priceFormGroup.controls.linearPriceMinStepInMinutes"></app-error-messages>
          </div>
        </div>
        <div class="form-row row">
          <label class="col-2 control-label required">{{'i18n.domain.administration.tariff-details.price-tab.price-per-hour' | translate}}</label>

          <div class="col-10 col-lg-4 input-wrapper">
            <ejs-numerictextbox format='n2' decimals="2" formControlName="pricePerHour" name='pricePerHour' validateDecimalOnType="true" min="0"></ejs-numerictextbox>
            <span class="multichar-unit-numerictextbox">{{'i18n.shared.currencies.' + CurrencyEnum[priceFormGroup.controls.tariffCurrency.value] | translate}}</span>
            <app-error-messages [control]="priceFormGroup.controls.pricePerHour"></app-error-messages>
          </div>
          <label class="col-2 control-label">{{'i18n.domain.administration.tariff-details.price-tab.max-price' | translate}}:</label>

          <div class="col-10 col-lg-4 mt-2 mt-lg-0 input-wrapper">
            <ejs-numerictextbox format='n2' decimals="2" formControlName="maximumPrice" name='maximumPrice' validateDecimalOnType="true" min="0"></ejs-numerictextbox>
            <span class="multichar-unit-numerictextbox">{{'i18n.shared.currencies.' + CurrencyEnum[priceFormGroup.controls.tariffCurrency.value] | translate}}</span>
            <app-error-messages [control]="priceFormGroup.controls.maximumPrice"></app-error-messages>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="PriceTypeEnum.FixedPrice" class="form-row row">
        <label class="col-2 control-label required">{{'i18n.domain.administration.tariff-details.price-tab.fixed-price' | translate}}:</label>

        <div class="col-10 col-lg-4 input-wrapper">
          <ejs-numerictextbox format='n2' decimals="2" formControlName="fixedPrice" name='fixedPrice' validateDecimalOnType="true" min="0"></ejs-numerictextbox>
          <span class="multichar-unit-numerictextbox">{{'i18n.shared.currencies.' + CurrencyEnum[priceFormGroup.controls.tariffCurrency.value] | translate}}</span>
          <app-error-messages [control]="priceFormGroup.controls.fixedPrice"></app-error-messages>
        </div>
      </div>

      <div *ngSwitchCase="PriceTypeEnum.TieredPrice">
        <div class="form-row row">
          <app-tariff-details-prices-tiered-prices-grid [priceFormGroup]="priceFormGroup" [maxParkingDuration]="maxParkingDuration"></app-tariff-details-prices-tiered-prices-grid>
        </div>
      </div>
    </ng-container>
  </div>
</div>
